import { defineMessages } from 'react-intl';

export default defineMessages({
  edoManager: {
    id: 'homepage.edoManager',
    defaultMessage: 'Ecommerce Delivery Options Manager',
  },
});
